<!-- 我的应用 -->
<template>
  <div class="el-MyApps">
    <el-row class="content_block mb30">
      <el-row class="title_head">
        <span class="class_img">
          <el-image class="title_img" :src="yingyong"></el-image>
        </span>
        <span>我的应用</span>
      </el-row>
      <el-divider></el-divider>
      <el-row class="p20" style="min-height: 320px;overflow: auto;">
        <ul v-if="myAppsList.length > 0">
          <template v-for="(item, index) in myAppsList">
            <li :key="index" @click="openNewWindow(item)">
              <el-image class="apps_img c_p" :src="$getUrl(item.thumbnailUrl)"></el-image>
              <p class="limit_line_one c_p mt10" style="margin-bottom: 0;font-size: 12px;">{{item.applicationName}}</p>
            </li>
          </template>
        </ul>
        <el-empty v-else :imageSize="60" description="暂无应用"></el-empty>
      </el-row>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "MyApps",
  data() {
    return {
      yingyong:require("../../images/index/yingyong@2x.png"),
      type:this.$route.query.type,
      myAppsList: [],
      timeIn:null,
      queryParams:{
        page:1,
        limit:50
      }
    };
  },
  created() {
    this.getInfo();
    //this.addSystem();
  },
  mounted() {
  },
  methods: {
    getInfo(){
      this.$post("/api/base/myPageApplication.do",this.queryParams).then((ret) =>{
        if(ret.code == 0){
          this.myAppsList = ret.data;
          this.$forceUpdate();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    /**
     * 打开新窗口页面
     * @param item
     */
    openNewWindow(item) {
      // if (item.realUrl) {
      //   window.open(item.realUrl)
      // }
       this.$router.push({name:'MyAppsDetails2',query:{id:item.resourcesApplicationId}});
    },
    addSystem(){ //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get('timeNum'); //获取统一
      this.timeIn = setInterval(()=>{
        let param = {
          firstName:"我的应用",//一级名称
          secondName:"我的应用",//二级名称
          useDuration:timeNum / 1000 / 60 //单次使用时长（单位：分钟）
        }
        this.$addSystemUseLog(param);
      },timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
  }
};
</script>
 <style  lang="less">
  .el-MyApps{
    padding: 20px 20px 0;
    ul{
      list-style-type:none;
      margin: 0;
      padding: 0;
    }
    li{
      float: left;
      width: 230px;
      text-align: center;
      padding: 0 20px 20px;
    }
    .content_block{
      background-color: #ffffff;
      .title_head{
        padding: 10px 20px;
      }
      .title_img{
        width: 20px;
      }
      .wdkc_img{
        width: 300px;
        height: 150px;
      }
      .wdkc_c{
        width: 300px;
      }
      .el-divider--horizontal{
        margin: 0;
      }
      .class_img{
        float: left;margin-right: 10px;
      }
      .echarts_row{
        padding: 20px;
      }
    }
    .apps_img{
      width: 120px;
      height: 120px;
      border-radius: 10px;
    }
  }
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/myApps/MyApps.vue